import type { Volume } from '@/features/bidding/types/bid'
import { decimalAdjust } from '@/features/bidding/utils/calculations/decimalAdjust'

export const calculateAverageVolume = (volumes: Volume[]): Volume | undefined => {
  if (!volumes || volumes.length === 0) return undefined

  const totalQuantity = volumes.reduce((sum, volume) => sum + volume.quantity, 0)
  return { quantity: decimalAdjust('round', totalQuantity / volumes.length, -2), unit: volumes[0].unit }
}
